const LOCAL_IMAGE = /^\/(?:assets|aramfix-spa\/assets)\//;

export const optimizedImageUrl = (source, width) => {
  if (!source || !LOCAL_IMAGE.test(source)) return source;
  return `/_next/image?url=${encodeURIComponent(source)}&w=${width}&q=75`;
};

export const responsiveImage = (source, widths, sizes) => ({
  src: source,
  srcSet: LOCAL_IMAGE.test(source || "")
    ? widths.map((width) => `${optimizedImageUrl(source, width)} ${width}w`).join(", ")
    : undefined,
  sizes,
});